"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equals = void 0;

// Works only with Scalar array
var equals = function equals(v1, v2) {
  if (v1 === v2) {
    return true;
  }

  if (Array.isArray(v1) && Array.isArray(v2)) {
    return v1.length === v2.length && v1.every(function (v, i) {
      return v2[i] === v;
    });
  }

  return false;
};

exports.equals = equals;